"use client"

import { VideoCorner } from 'react-video-corner';
import React from 'react';

export const StickyVideo = () => {
  return <div className={'react-video-corner'}>
    <VideoCorner
      videoSrc={'https://pub-587b85b926c544ebbd97070d6130868a.r2.dev/IMG_1560.MOV'}
      isYoutube={false}
      position='bottom-right'
      smallSize={140}
      largeSize={238}
      borderRadius={10}
      borderColor='black'
      backgroundColor='#ffffff'
      autoplay={true}
      initiallyMuted={true}
    />
  </div>
};